import program_alumni_recruitment from "../../../../assets/images/nml/program_alumni_recruitment.webp";
import experienced_hires_banner from "../../../../assets/images/nml/experienced_hire_banner.webp";

import {
  BASENAME_PAGE,
  NML_PAGE,
  WORKDAY_EN_PATH,
  WORKDAY_JP_PATH,
} from "../../../../interfaces/Static/routing_paths";

export const NML_ALUMNI_RECRUITMENT = {
  id: "alumni-recruitment",
  card_src: program_alumni_recruitment,
  card_title: "page.nml.alumni_recruitment.card.title",
  card_description: "page.nml.alumni_recruitment.card.description",
  banner_src: experienced_hires_banner,
  banner_title: "page.nml.alumni_recruitment.banner.title",
  banner_description: "page.nml.alumni_recruitment.banner.description",
  slug: "alumni-recruitment",
  href: `${BASENAME_PAGE + NML_PAGE}/alumni-recruitment`,
  external: true,
  name: "page.nml.alumni_recruitment.name",
  description: "",
  isAlumniRecruitment: true,
  work_day_link: `${WORKDAY_EN_PATH}locationCountry=8b705da2becf43cfaccc091da0988ab2`,
  work_day_link_jp: `${WORKDAY_JP_PATH}locationCountry=8b705da2becf43cfaccc091da0988ab2`,
};
